import React from "react";

const AmbulanceGallery = () => {
  const images = [
    "/assets/images/ambulance_1.jpg",
    "/assets/images/ambulance_2.jpg",
  ];
  return (
    <div className="my-5 shadow bg-body rounded p-4">
      <h4 className="text-start">Ambulance</h4>
      <div className="row">
        {images.map((item, index) => (
          <div className="col-md-4 col-sm-6 mb-3">
            <img src={item} alt="Image 7" className="img-fluid" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AmbulanceGallery;



// WEBPACK FOOTER //
// ./src/component/frontend/AmbulanceGallery.js